var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view === 'table')?_c('ehc-properties-table',_vm._g(_vm._b({},'ehc-properties-table',_vm.$attrs,false),_vm.$listeners)):_vm._e(),(_vm.view === 'gallery')?_c('ehc-properties-gallery',_vm._g(_vm._b({},'ehc-properties-gallery',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }